import axios from "axios";

const service = axios.create({
  baseURL: "https://api-lefeng365.linhebj.top/api/v1/manger",
  timeout: 15000,
});

// 请求拦截器：添加 token
service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("admin_token");
    if (token && token !== "mock_token") {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    // 后端 resReturn(1, data) 返回 { result: 'ok', message: data }
    // 后端 resReturn(0, msg)  返回 { result: 'error', message: msg, code: xxx }
    if (res.result === "ok") {
      // 成功时，message 里才是真正的数据
      return res.message ?? res;
    }
    // 认证失败
    if (res.code === 50002) {
      localStorage.removeItem("admin_token");
      window.location.hash = "#/login";
    }
    return Promise.reject(new Error(res.message || "请求失败"));
  },
  (error) => {
    return Promise.reject(error);
  },
);

// ============ 登录 ============
export function login(data) {
  return service.post("/login", data);
}
export function getUserInfo() {
  return service.get("/userInfo");
}
export function logout() {
  return service.post("/logout");
}

// ============ 首页 ============
export function getDashboard() {
  return service.get("/dashboard");
}

// ============ 普惠商品 ============
export function getProducts(params) {
  return service.get("/products", { params });
}
export function getProductDetail(id) {
  return service.get(`/products/${id}`);
}
export function createProduct(data) {
  return service.post("/products", data);
}
export function updateProduct(id, data) {
  return service.post(`/products/${id}`, data);
}
export function toggleProductStatus(data) {
  return service.post("/products/toggleStatus", data);
}
export function batchProductOn(data) {
  return service.post("/products/batchOn", data);
}
export function batchProductOff(data) {
  return service.post("/products/batchOff", data);
}
export function batchProductDestroy(data) {
  return service.post("/products/batchDestroy", data);
}
export function getProductSkus(id) {
  return service.get(`/products/skus/${id}`);
}
export function updateProductVirtualSales(data) {
  return service.post("/products/updateVirtualSales", data);
}

// 分类
export function getCategories(params) {
  return service.get("/categories", { params });
}
export function createCategory(data) {
  return service.post("/categories", data);
}
export function updateCategory(id, data) {
  return service.post(`/categories/${id}`, data);
}
export function toggleCategoryStatus(id) {
  return service.post(`/categories/toggleStatus/${id}`);
}

// ============ 商品审核（甄选/臻赏/爆品） ============
export function getReviews(params) {
  return service.get("/reviews", { params });
}
export function getReviewDetail(id) {
  return service.get(`/reviews/${id}`);
}
export function approveReview(data) {
  return service.post("/reviews/approve", data);
}
export function rejectReview(data) {
  return service.post("/reviews/reject", data);
}

// ============ 全域订单 ============
export function getCommonOrders(params) {
  return service.get("/orders/common", { params });
}
export function getReportOrders(params) {
  return service.get("/orders/report", { params });
}
export function getTodayFlowOrders(params) {
  return service.get("/orders/todayFlow", { params });
}
export function getOrderDetail(params) {
  return service.get("/orders/detail", { params });
}
export function orderShipment(data) {
  return service.post("/orders/shipment", data);
}
export function orderRefund(data) {
  return service.post("/orders/refund", data);
}
export function markOrderAbnormal(data) {
  return service.post("/orders/markAbnormal", data);
}

// ============ 全平台会员 ============
export function getMembers(params) {
  return service.get("/members", { params });
}
export function getMemberDetail(id) {
  return service.get(`/members/${id}/detail`);
}
export function getMemberLogs(id, params) {
  return service.get(`/members/${id}/logs`, { params });
}

// ============ 分身账号管理 ============
export function getApplyList(params) {
  return service.get("/accounts/apply", { params });
}
export function approveApply(data) {
  return service.post("/accounts/approveApply", data);
}
export function rejectApply(data) {
  return service.post("/accounts/rejectApply", data);
}
export function getBranchList(params) {
  return service.get("/accounts/branches", { params });
}
export function createAccount(data) {
  return service.post("/accounts/create", data);
}
export function updateAccount(data) {
  return service.post("/accounts/update", data);
}
export function refundDeposit(data) {
  return service.post("/accounts/refundDeposit", data);
}
export function renewBranch(data) {
  return service.post("/accounts/renew", data);
}

// ============ 平台财务 ============
export function getFinance() {
  return service.get("/finance");
}
export function getFlowList(params) {
  return service.get("/finance/flowList", { params });
}
export function getFinanceBranches() {
  return service.get("/finance/branches");
}

// ============ 龙虎榜 ============
export function getLeaderboard(params) {
  return service.get("/leaderboard", { params });
}

// ============ 会员商户信息审核 ============
export function getMerchantList(params) {
  return service.get("/merchant", { params });
}
export function auditMerchant(data) {
  return service.post("/merchant/audit", data);
}

// ============ 托管商品管理（全平台） ============
export function getCloudWarehouse(params) {
  return service.get("/cloudWarehouse", { params });
}
export function getCloudWarehouseStats(params) {
  return service.get("/cloudWarehouse/stats", { params });
}
export function getCloudWarehouseBranches() {
  return service.get("/cloudWarehouse/branches");
}

// ============ 可委托公司管理 ============
export function getDelegatedCompanies(params) {
  return service.get("/delegatedCompanies", { params });
}
export function createDelegatedCompany(data) {
  return service.post("/delegatedCompanies", data);
}
export function updateDelegatedCompany(data) {
  return service.post("/delegatedCompanies/update", data);
}
export function toggleDelegatedCompany(data) {
  return service.post("/delegatedCompanies/toggleStatus", data);
}
export function deleteDelegatedCompany(data) {
  return service.post("/delegatedCompanies/destroy", data);
}

// ============ 委托账户管理 ============
export function getDelegatedAccountMembers(params) {
  return service.get("/delegatedAccounts/members", { params });
}
export function transferDelegatedAccount(data) {
  return service.post("/delegatedAccounts/transfer", data);
}
export function getDelegatedAccountFlowLogs(params) {
  return service.get("/delegatedAccounts/flowLogs", { params });
}

// ============ 系统配置 ============
export function getSystemConfigs(params) {
  return service.get("/config", { params });
}
export function saveSystemConfigs(data) {
  return service.post("/config", data);
}

// ============ 售后管理 ============
export function getAfterSales(params) {
  return service.get("/afterSale", { params });
}
export function getAfterSaleDetail(id) {
  return service.get(`/afterSale/${id}`);
}
export function auditAfterSale(data) {
  return service.post("/afterSale/audit", data);
}
export function signAfterSale(data) {
  return service.post("/afterSale/sign", data);
}

// ============ RBAC 权限管理 ============
// 管理员管理
export function getRbacAdmins(params) {
  return service.get("/rbac/admins", { params });
}
export function createRbacAdmin(data) {
  return service.post("/rbac/admins", data);
}
export function updateRbacAdmin(id, data) {
  return service.post(`/rbac/admins/${id}`, data);
}
export function deleteRbacAdmin(id) {
  return service.post(`/rbac/admins/destroy/${id}`);
}
export function getRbacRolesAll() {
  return service.get("/rbac/roles-all");
}
export function getRbacDelegatedCompanies() {
  return service.get("/rbac/delegated-companies");
}

// 角色管理
export function getRbacRoles(params) {
  return service.get("/rbac/roles", { params });
}
export function getAllRoles() {
  return service.get("/rbac/roles/all");
}
export function createRbacRole(data) {
  return service.post("/rbac/roles", data);
}
export function updateRbacRole(id, data) {
  return service.post(`/rbac/roles/${id}`, data);
}
export function deleteRbacRole(id) {
  return service.post(`/rbac/roles/destroy/${id}`);
}

// 权限管理
export function getRbacPermissions(params) {
  return service.get("/rbac/permissions", { params });
}
export function getRbacPermissionTree() {
  return service.get("/rbac/permissions/tree");
}
export function createRbacPermission(data) {
  return service.post("/rbac/permissions", data);
}
export function updateRbacPermission(id, data) {
  return service.post(`/rbac/permissions/${id}`, data);
}
export function deleteRbacPermission(id) {
  return service.post(`/rbac/permissions/destroy/${id}`);
}

// ============ 供货商管理 ============
export function getDistributors(params) {
  return service.get("/distributors", { params });
}
export function getAllDistributors() {
  return service.get("/distributors/all");
}
export function getDistributorDetail(params) {
  return service.get("/distributors/detail", { params });
}
export function createDistributor(data) {
  return service.post("/distributors/create", data);
}
export function updateDistributor(data) {
  return service.post("/distributors/update", data);
}
export function toggleDistributor(data) {
  return service.post("/distributors/toggleStatus", data);
}
export function deleteDistributor(data) {
  return service.post("/distributors/destroy", data);
}
// 供货商后台账号
export function getDistributorRoles() {
  return service.get("/distributors/roles");
}
export function getDistributorAdmins(params) {
  return service.get("/distributors/admins", { params });
}
export function createDistributorAdmin(data) {
  return service.post("/distributors/admins/create", data);
}
export function updateDistributorAdmin(data) {
  return service.post("/distributors/admins/update", data);
}
export function deleteDistributorAdmin(data) {
  return service.post("/distributors/admins/destroy", data);
}
